module.exports = __webpack_public_path__ + "img/4-2.134ac53c.png";